import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DonutChart } from "../../../../Constant";
import Chart from "react-apexcharts";
import { DONUT_CHART } from "../../../../Data/Charts/ApexChart";

const DonutCharts = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={DonutChart} />
        <CardBody>
          <div id="donutchart">
            <Chart options={DONUT_CHART} series={DONUT_CHART.series} type="pie" height={300} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DonutCharts;
